import { emptySplitApi } from "./empty-split-api";
import {
  ManufacturersFilter,
  ManufacturersResponse
} from "./types/manufacturers.type";

const extendedManufacturersApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getManufacturers: builder.query<ManufacturersResponse, ManufacturersFilter>(
      {
        query: ({ search, practice_filtered, include_in_use }) => {
          let url = `manufacturers/?limit=300&search=${encodeURIComponent(search)}`;
          if (practice_filtered) {
            url += `&practice_filtered=true`;
          }
          if (include_in_use) {
            url += `&include_in_use=true`;
          }
          return url;
        },
        providesTags: ["Manufacturers"]
      }
    )
  })
});

export const { useGetManufacturersQuery } = extendedManufacturersApi;
